export default __webpack_public_path__ + "static/implementierung-29aab191308bdb2a52105e032dd0b632.svg";